/**
 * 审核流程（auditprocess）模块英文映射（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/auditprocess/ 下 我的审核、我的申请、审核员-操作员关联
 *          列表及其详情/审核弹窗
 * 术语：审核=Review，流程=Process，记录=Record，补水=Water Supplement，
 *       审核员=Reviewer，操作员=Operator，申请人=Applicant，申请=Application
 */
export default {
  'audit_record管理页面': 'Review Record Management Page',
  'audit_user_link管理页面': 'Review User Link Management Page',
  '下载': 'Download',
  '交易方式': 'Payment Method',
  '价格信息': 'Price Info',
  '价格名称': 'Price Name',
  '元': 'CNY',
  '充值日期': 'Recharge Date',
  '共{total}条': 'Total {total} records',
  '关闭': 'Close',
  '关闭启用': 'Disable',
  '其他': 'Other',
  '创建人': 'Created By',
  '创建时间': 'Created At',
  '删除': 'Delete',
  '剩余金额(元)': 'Remaining Balance (CNY)',
  '单次最大购买金额(元)': 'Max Single Purchase Amount (CNY)',
  '启用': 'Enabled',
  '备注': 'Remark',
  '实际补水金额(元)': 'Actual Water Supplement Amount (CNY)',
  '审核': 'Review',
  '审核不通过': 'Rejected',
  '审核人员': 'Reviewer',
  '审核信息': 'Review Information',
  '审核员': 'Reviewer',
  '审核意见': 'Review Opinion',
  '审核时间': 'Review Time',
  '审核状态': 'Review Status',
  '审核通过': 'Approved',
  '导出': 'Export',
  '展开': 'Expand',
  '已选择 {count} 项': '{count} items selected',
  '待审核': 'Pending Review',
  '我的审核': 'My Reviews',
  '我的申请': 'My Applications',
  '手机号码': 'Mobile Phone',
  '批量操作': 'Batch Operations',
  '按吨数': 'By Tonnage',
  '按金额': 'By Amount',
  '描述': 'Description',
  '操作': 'Action',
  '操作员': 'Operator',
  '收起': 'Collapse',
  '新增': 'Add',
  '无图片': 'No Image',
  '无文件': 'No File',
  '是否启用': 'Enabled',
  '最大囤积金额(元)': 'Max Stockpile Amount (CNY)',
  '未启用': 'Not Enabled',
  '查询': 'Query',
  '清空': 'Clear',
  '用户信息': 'Customer Info',
  '用户地址': 'Customer Address',
  '用户姓名': 'Customer Name',
  '用户编号': 'Customer No.',
  '用水单价(元)': 'Water Unit Price (CNY)',
  '申请人': 'Applicant',
  '申请时间': 'Application Time',
  '确定关闭启用吗?': 'Are you sure to disable?',
  '确定删除吗?': 'Are you sure you want to delete?',
  '确定启用吗?': 'Are you sure to enable?',
  '缴费途径': 'Payment Channel',
  '营业厅': 'Business Hall',
  '营业厅现金': 'Cash at Business Hall',
  '扫码支付': 'QR Code Payment',
  '对公转账': 'Corporate Bank Transfer',
  '微信支付': 'WeChat Pay',
  '补水前余额(元)': 'Balance Before Water Supplement (CNY)',
  '补水吨数(吨)': 'Water Supplement Volume (t)',
  '补水备注': 'Water Supplement Remarks',
  '补水审核详情': 'Water Supplement Review Details',
  '补水申请信息': 'Water Supplement Application Information',
  '补水记录': 'Water Supplement Records',
  '补水量(吨)': 'Water Supplement Volume (t)',
  '补水金额(元)': 'Water Supplement Amount (CNY)',
  '表编号': 'Meter No.',
  '计费类型': 'Billing Type',
  '订单号': 'Order No.',
  '详情': 'Details',
  '请输入任务名称': 'Please enter task name',
  '请输入备注': 'Please enter remark',
  '请选择任务类型': 'Please select task type',
  '请选择审核员': 'Please select reviewer',
  '请选择审核状态': 'Please select review status',
  '请选择操作员': 'Please select operator',
  '购买金额(元)': 'Purchase Amount (CNY)',
  '重置': 'Reset',
}
